export default __webpack_public_path__ + "static/bgpensions-279895b28cce495777bba0ab86223da6.png";